import Hook from "../../utils/hook"
import { scrollIntoView } from "../../utils/scroll"

export const ExplorePage = Hook(`ExplorePage`, {
  refs: [`map`],

  mapRefMounted(mapRef) {
    mapRef.addReceiveHandler(this.mapReceive.bind(this))
  },

  mapReceive(message) {
    switch (message.method) {
      case `loaded`: {
        if (this.mapRef && window.location.hash == `#${this.mapRef.el.id}`)
          this.enterMapFullscreen()
        break
      }

      case `setQuery`: {
        this.mapQueryWasSet(message.data)
        break
      }
    }
  },

  enterMapFullscreen() {
    if (!this.mapRef) return

    scrollIntoView(this.mapRef.el, { block: `center` }).then(() => {
      if (this.mapRef) this.mapRef.setFullscreen(true)
    })
  },

  mapQueryWasSet(query) {
    if (!this.mapRef) return

    const urlTypes = this.mapRef.el.dataset.urlTypes.split(`,`)
    const params = {}

    query.forEach((q) => {
      if (urlTypes.includes(q.type)) {
        params[q.type] = params[q.type] || []
        params[q.type].push(q.value)
      }
    })

    let url = Object.entries(params)
      .map(([k, v]) => `${k}=${v.join(`,`)}`)
      .join(`&`)

    if (url && this.mapRef.el.id) url += `#${this.mapRef.el.id}`

    window.history.replaceState(null, null, `?${url}`)
  },
})
